// Whose card a row was charged on, from the server's `card_view`
// (.claude/references/cardholder-reporting.md). The rule that decides the scope
// lives only on the server, so the screen and Livi can't disagree; these just
// turn it into labels. A missing card_view (older backend) is no card.
export const CARD_ACCOUNT_LEVEL_LABEL = 'Account-level';
export const CARD_UNATTRIBUTED_LABEL = 'Card not identified';
export const NOT_A_CARD_LABEL = 'Not a card account';

export const isCardRow = (transaction) => transaction?.card_view?.scope === 'CARD';

export const deriveCardholderName = (cardView) => {
  if (cardView?.scope === 'CARD') return cardView.holder || 'Unnamed cardholder';
  if (cardView?.scope === 'ACCOUNT_LEVEL') return CARD_ACCOUNT_LEVEL_LABEL;
  // A card account charge the statement didn't tie to a card: no one's.
  if (cardView?.scope === 'UNATTRIBUTED') return CARD_UNATTRIBUTED_LABEL;
  return NOT_A_CARD_LABEL;
};

// Last 4 of the card, or null. A card_key of `holder:<NAME>` means the
// statement printed no card number.
export const deriveCardEnding = (cardView) => {
  const key = cardView?.scope === 'CARD' ? cardView.card_key : null;
  return key && !key.startsWith('holder:') ? key : null;
};

export const deriveCardLabel = (cardView) => {
  const ending = deriveCardEnding(cardView);
  return ending ? `Ending ${ending}` : deriveCardholderName(cardView);
};
